// extracted by mini-css-extract-plugin
export default {"graphCard":"styles_graphCard__YEcbV"};